<template>
<div>
    <div class="login_wrap">
        <dl>
            <dt>휴대폰 본인인증</dt>
            <dd>
                휴대폰 본인인증 후 연락처가 변경 됩니다.
            </dd>
        </dl>

        

        <!-- <ul class="login_form">
            <li>
                <input type="text" placeholder="변경할 휴대폰 번호" v-model="phone">
                <button class="certify_btn" @click="niceAuth();">본인인증</button>
            </li>
        </ul> -->

    </div>
    <div class="btn_box_fixed">
        <a class="default_btn1" @click="niceAuth();">본인인증</a>
    </div>
</div>

</template>

<script>
import {NiceMixin} from '../../../mixins/NiceMixin';
export default {
    name:'PhoneNiceAuth',
    mixins:[NiceMixin],
    created() {
        this.$store.commit('SHOW_ONLOAD');
    },

    data() {
        return {
            // phone: "",
        }
    },
    methods: {
        //본인 인증
        niceAuth() {
            // if(!this.phone) {
            //     return this.$store.commit('OPEN_MODAL', {
            //         content: '핸드폰 번호를 입력해주세요.',
            //         btnOne: '확인',
            //     });
            // }
            this.callbackPopup('Nice', this.niceResult)
        },

        //본인 인증 성공
        niceResult() {
            let niceData = this.niceGetResult();
            //성공시에만 niceData 존재
            if(niceData) {
                this.$store.dispatch('CHANGE_USER_PHPNE_CHECK', niceData.phone)
                .then(()=>{
                    this.phoneChangeSubmit(niceData.phone);
                })
                .catch((e)=>{
                    this.apiCatch(e);
                })
            }
        },

        phoneChangeSubmit(phone) {
            this.$store.dispatch('CHANGE_USER_PHPNE', { 
                phone,
                // inputPhone,
            })
            .then((data) => {
                this.auth.phone = data.phone;
                this.$router.push('/phone/complete');
            })
            .catch((e) => {
                this.apiCatch(e);
            })
        }
    },
    
}
</script>

<style lang="scss" scoped>

</style>